var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAfterBlackFridayDesktop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1450,
    height: 801,
    viewBox: "0 0 1450 801",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173512",
    "data-name": "Rectangle 173512",
    width: 1440,
    height: 784,
    transform: "translate(0 117)"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 0.498,
    cy: 0.496,
    r: 0.491,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1a1818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.187,
    stopColor: "#1d1b1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.352,
    stopColor: "#262426"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.371,
    stopColor: "#282628"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.483,
    stopColor: "#222022"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.758,
    stopColor: "#1a1818"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.716,
    x2: 0.5,
    y2: 0.159,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.333
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "banner_image",
    "data-name": "banner image",
    transform: "translate(10 -109)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_15671",
    "data-name": "Mask Group 15671",
    transform: "translate(0 -3)",
    opacity: 0.927,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61963",
    "data-name": "Path 61963",
    d: "M630.218,1604.1H746L688.1,694.427ZM746-223.265H630.218L688.1,686.408Zm760.323,507.1-57.888-100.518L691.57,688.412ZM-130.109,1097l57.889,100.519,756.861-505.1Zm1578.541,100.518L1506.32,1097,691.57,692.423ZM-72.22,183.316l-57.888,100.52L684.64,688.412Zm764.327,507.1,907.369,58.034,0-116.069Zm-915.372-58.036V748.453l907.372-58.036ZM1193.922-71.837l-100.261-58.034L690.1,686.945ZM182.286,1452.672l100.267,58.036L686.106,693.89Zm911.372,58.035,100.267-58.035L690.108,693.89ZM282.553-129.873,182.289-71.837,686.106,686.945ZM868.071,1587.986,979.9,1557.946,689.143,694.292ZM508.144-207.151,396.31-177.111l290.76,863.654Zm865.33,292.536L1291.611,3.311,690.935,687.581ZM2.736,1295.452,84.6,1377.525,685.276,693.254Zm1550.7-312.5L1583.4,870.838,691.971,691.456ZM-177.227,397.882-207.192,510,684.24,689.38ZM1583.4,510l-29.965-112.115L691.971,689.38Zm-1790.6,360.841,29.964,112.117,861.467-291.5ZM979.9-177.111l-111.832-30.04L689.143,686.543ZM396.309,1557.946l111.835,30.042,178.927-893.7Zm895.3-180.422,81.866-82.072-682.541-602.2ZM84.6,3.31,2.738,85.383l682.539,602.2Z",
    transform: "translate(19.14 -310.445)",
    fill: "url(#radial-gradient)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173517",
    "data-name": "Rectangle 173517",
    width: 1440,
    height: 801,
    transform: "translate(-10 109)",
    opacity: 0.547,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_176859",
    "data-name": "Group 176859",
    transform: "translate(-1012.479 -197.575)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176824",
    "data-name": "Group 176824",
    transform: "translate(1446.876 682.773)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176813",
    "data-name": "Group 176813",
    transform: "translate(0 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61921",
    "data-name": "Path 61921",
    d: "M1377.312,1042.294V1003.07h36.9q7.908,0,11.2,2.5a7.714,7.714,0,0,1,3.3,6.405v.58a6.685,6.685,0,0,1-2.109,5.193,10.211,10.211,0,0,1-4.64,2.5,14.673,14.673,0,0,1,2.926,1,17.232,17.232,0,0,1,2.847,1.74,7.546,7.546,0,0,1,2.372,3.005,10.264,10.264,0,0,1,.87,4.323v.633q0,11.335-16.554,11.334Zm32.37-30.314h-17.4v5.536h17.4q4.006,0,4.006-2.741v-.105Q1413.689,1011.979,1409.682,1011.98Zm.949,14.34h-18.346v6.748h18.346q4.639,0,4.64-3.374v-.158Q1415.27,1026.32,1410.631,1026.319Z",
    transform: "translate(-1377.312 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176814",
    "data-name": "Group 176814",
    transform: "translate(56.831 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61922",
    "data-name": "Path 61922",
    d: "M2092.87,1003.07h14.972v27.994h27.2v11.229H2092.87Z",
    transform: "translate(-2092.87 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176815",
    "data-name": "Group 176815",
    transform: "translate(100.22 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61923",
    "data-name": "Path 61923",
    d: "M2682.818,1042.294l-3.058-6.326h-22.406l-3.005,6.326h-15.183l19.4-39.224h20.139l20.507,39.224Zm-7.856-16.132-6.59-13.5-6.431,13.5Z",
    transform: "translate(-2639.165 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176816",
    "data-name": "Group 176816",
    transform: "translate(157 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61924",
    "data-name": "Path 61924",
    d: "M3383.86,1034.477H3381.8a47.708,47.708,0,0,1-12.1-1.37,25.656,25.656,0,0,1-8.093-3.4,17.179,17.179,0,0,1-4.691-4.824,16.336,16.336,0,0,1-2.321-5.166,22.793,22.793,0,0,1-.526-4.956v-1.529a23.435,23.435,0,0,1,.5-4.955,17.171,17.171,0,0,1,6.853-9.832,25.791,25.791,0,0,1,8.12-3.322,49.722,49.722,0,0,1,12.257-1.344h2.055a58.961,58.961,0,0,1,8.989.633,37.236,37.236,0,0,1,6.854,1.634,23.617,23.617,0,0,1,4.9,2.4,15.588,15.588,0,0,1,3.349,2.821,13.889,13.889,0,0,1,1.977,3.031,12.059,12.059,0,0,1,1,2.873,13.429,13.429,0,0,1,.237,2.478v.685h-15.552q-1.793-6.01-12.917-6.01-13.128,0-13.127,9.173v.633a9.213,9.213,0,0,0,.605,3.322,9.933,9.933,0,0,0,2,3.11,9.448,9.448,0,0,0,4.112,2.425,20.659,20.659,0,0,0,6.458.9,24.319,24.319,0,0,0,5.746-.607,14.542,14.542,0,0,0,3.743-1.344,7.14,7.14,0,0,0,2.11-1.845,6.931,6.931,0,0,0,1-1.582q.158-.474.316-1.054h15.5v.843a13.509,13.509,0,0,1-.527,3.664,13.107,13.107,0,0,1-2.32,4.217,17.2,17.2,0,0,1-4.612,4.112,26.912,26.912,0,0,1-7.961,2.979A52.158,52.158,0,0,1,3383.86,1034.477Z",
    transform: "translate(-3354.074 -993.777)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176817",
    "data-name": "Group 176817",
    transform: "translate(217.68 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61925",
    "data-name": "Path 61925",
    d: "M4133.061,1042.294h-14.972V1003.07h14.972v15.5l19.3-15.5h18.611l-22.829,17.819,23.566,21.4H4152.2l-19.139-17.555Z",
    transform: "translate(-4118.089 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176818",
    "data-name": "Group 176818",
    transform: "translate(288.85 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61926",
    "data-name": "Path 61926",
    d: "M5014.187,1003.07h42.545v9.595H5029v4.9h27.15v9.648H5029v15.078h-14.814Z",
    transform: "translate(-5014.187 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176819",
    "data-name": "Group 176819",
    transform: "translate(335.771 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61927",
    "data-name": "Path 61927",
    d: "M5619.936,1028.85v13.443h-14.973V1003.07H5640.6q16.5,0,16.5,10.07v.58a8.238,8.238,0,0,1-.792,3.638,7.261,7.261,0,0,1-2.083,2.636,13.515,13.515,0,0,1-2.528,1.582,13.814,13.814,0,0,1-2.5.9,10.931,10.931,0,0,1,5.9,3.242,8.756,8.756,0,0,1,2.161,6.089v5.8a9.868,9.868,0,0,0,.738,4.428v.264h-15.288a3.191,3.191,0,0,1-.475-2.056v-4.587q0-3.479-1.818-5.14t-6.143-1.661Zm0-16.238v6.748h17.186q4.534,0,4.534-3.374v-.053q0-3.321-4.534-3.321Z",
    transform: "translate(-5604.963 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176820",
    "data-name": "Group 176820",
    transform: "translate(392.181 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61928",
    "data-name": "Path 61928",
    d: "M6330.129,1003.07v39.224h-14.921V1003.07Z",
    transform: "translate(-6315.208 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176821",
    "data-name": "Group 176821",
    transform: "translate(412.161 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61929",
    "data-name": "Path 61929",
    d: "M6566.783,1042.294V1003.07h27.836a57.258,57.258,0,0,1,11.6,1.054,29.043,29.043,0,0,1,8.173,2.794,17.084,17.084,0,0,1,5.089,4.217,14.666,14.666,0,0,1,2.714,5.009,19.54,19.54,0,0,1,.739,5.483v1.582a21.479,21.479,0,0,1-.66,5.43,14.981,14.981,0,0,1-2.583,5.114,16.933,16.933,0,0,1-4.957,4.4,28.048,28.048,0,0,1-8.169,2.978,54.381,54.381,0,0,1-11.89,1.16Zm14.972-28.943v18.558h11.126q14.495,0,14.5-9.174v-.316q0-9.067-14.5-9.068Z",
    transform: "translate(-6566.783 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176822",
    "data-name": "Group 176822",
    transform: "translate(465.145 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61930",
    "data-name": "Path 61930",
    d: "M7277.539,1042.294l-3.057-6.326h-22.406l-3,6.326h-15.185l19.4-39.224h20.14l20.508,39.224Zm-7.854-16.132-6.59-13.5-6.431,13.5Z",
    transform: "translate(-7233.887 -1003.07)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176823",
    "data-name": "Group 176823",
    transform: "translate(513.331 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61931",
    "data-name": "Path 61931",
    d: "M7862.053,1042.294v-14.761L7840.6,1003.07h17.923l11.439,13.549,11.651-13.549h16.4l-20.982,24.568v14.656Z",
    transform: "translate(-7840.597 -1003.07)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176858",
    "data-name": "Group 176858",
    transform: "translate(1446.479 655.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176840",
    "data-name": "Group 176840",
    transform: "translate(0 73.234)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176825",
    "data-name": "Group 176825",
    transform: "translate(0 0.057)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61932",
    "data-name": "Path 61932",
    d: "M1409.824,1599.073h-37.512v-20.009h.794v19.215h36.718c5.411,0,9.512-.93,12.191-2.764a8.711,8.711,0,0,0,2.971-3.388,10.867,10.867,0,0,0,.995-4.785v-.633a9.926,9.926,0,0,0-.833-4.157,7.187,7.187,0,0,0-2.247-2.851c-.11-.081-.217-.155-.33-.234l-.11-.077.455-.651.108.075c.113.078.229.16.348.248a7.968,7.968,0,0,1,2.5,3.159,10.712,10.712,0,0,1,.906,4.488v.633C1426.775,1595.126,1421.072,1599.073,1409.824,1599.073Zm-3.8-9.226h-18.744V1582.3h18.744a6.529,6.529,0,0,1,3.706.875,3.127,3.127,0,0,1,1.331,2.738v.159a3.313,3.313,0,0,1-1.323,2.852A6.3,6.3,0,0,1,1406.028,1589.847Zm-17.949-.794h17.949c4.242,0,4.242-2.24,4.242-2.977v-.159c0-.7,0-2.819-4.242-2.819h-17.949Z",
    transform: "translate(-1372.312 -1578.739)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176826",
    "data-name": "Group 176826",
    transform: "translate(56.831 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61933",
    "data-name": "Path 61933",
    d: "M2130.84,1602.844h-42.97v-20.009h.794v19.214h41.382v-10.435h-27.2v-8.78h.794v7.985h27.2Z",
    transform: "translate(-2087.87 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176827",
    "data-name": "Group 176827",
    transform: "translate(122.763 0.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61934",
    "data-name": "Path 61934",
    d: "M2932.287,1584.692H2918l1.929-4.048.717.342-1.388,2.911h11.757l-1.42-2.908.714-.349Z",
    transform: "translate(-2918 -1580.641)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176828",
    "data-name": "Group 176828",
    transform: "translate(99.977 0.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61935",
    "data-name": "Path 61935",
    d: "M2692.457,1600.712h-17.3l-3.058-6.326h-21.9l-3,6.326h-16.074l9.983-20.186.711.353-9.417,19.039h14.293l3-6.326H2672.6l3.058,6.326h15.491l-9.95-19.031.7-.368Z",
    transform: "translate(-2631.113 -1580.518)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176829",
    "data-name": "Group 176829",
    transform: "translate(172.499 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61936",
    "data-name": "Path 61936",
    d: "M3557.805,1592.985a21.146,21.146,0,0,1-6.582-.917,9.882,9.882,0,0,1-4.281-2.534,10.344,10.344,0,0,1-2.081-3.236,9.636,9.636,0,0,1-.633-3.463h.793a8.842,8.842,0,0,0,.581,3.179,9.571,9.571,0,0,0,1.925,2.984,9.11,9.11,0,0,0,3.944,2.316,20.354,20.354,0,0,0,6.333.877,24.056,24.056,0,0,0,5.653-.6,14.273,14.273,0,0,0,3.637-1.3,6.748,6.748,0,0,0,1.993-1.743,6.281,6.281,0,0,0,.941-1.466c.1-.309.208-.656.31-1.033l.767.209c-.107.391-.216.753-.324,1.075a6.978,6.978,0,0,1-1.062,1.7,7.57,7.57,0,0,1-2.225,1.948,14.985,14.985,0,0,1-3.849,1.387A24.838,24.838,0,0,1,3557.805,1592.985Z",
    transform: "translate(-3544.229 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176830",
    "data-name": "Group 176830",
    transform: "translate(157 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61937",
    "data-name": "Path 61937",
    d: "M3379.257,1603.582H3377.2a48.34,48.34,0,0,1-12.2-1.383,26.146,26.146,0,0,1-8.219-3.46,17.678,17.678,0,0,1-4.8-4.935,16.791,16.791,0,0,1-2.373-5.294,23.291,23.291,0,0,1-.536-5.042v-.633h.794v.633a22.43,22.43,0,0,0,.518,4.87,16.008,16.008,0,0,0,2.266,5.038,16.868,16.868,0,0,0,4.585,4.713,25.372,25.372,0,0,0,7.966,3.342,47.529,47.529,0,0,0,12,1.358h2.056a51.97,51.97,0,0,0,11.8-1.2,26.683,26.683,0,0,0,7.841-2.928,16.9,16.9,0,0,0,4.508-4.017,12.822,12.822,0,0,0,2.253-4.084,13.158,13.158,0,0,0,.512-3.556v-.844h.794V1587a13.947,13.947,0,0,1-.542,3.772,13.593,13.593,0,0,1-2.386,4.351,17.713,17.713,0,0,1-4.718,4.207,27.419,27.419,0,0,1-8.08,3.028A52.78,52.78,0,0,1,3379.257,1603.582Z",
    transform: "translate(-3349.074 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176831",
    "data-name": "Group 176831",
    transform: "translate(217.68 0.088)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61938",
    "data-name": "Path 61938",
    d: "M4168.13,1599.437h-20.689l-18.585-17.049v17.049h-15.767v-20.009h.793v19.215h14.179v-18.062l19.689,18.062h18.323l-20.831-18.921.535-.588Z",
    transform: "translate(-4113.089 -1579.134)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176832",
    "data-name": "Group 176832",
    transform: "translate(288.85 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61939",
    "data-name": "Path 61939",
    d: "M5024.8,1602.844h-15.61v-20.009h.794v19.214H5024v-15.078h27.152v-4.137h.794v4.931H5024.8Z",
    transform: "translate(-5009.186 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176833",
    "data-name": "Group 176833",
    transform: "translate(335.771)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61940",
    "data-name": "Path 61940",
    d: "M5653.792,1598.417h-15.861l-.119-.131a3.485,3.485,0,0,1-.577-2.322v-4.586a6.3,6.3,0,0,0-1.689-4.847c-1.132-1.033-3.108-1.557-5.875-1.557H5615.73v13.443h-15.768v-20.008h.795v19.214h14.178V1584.18h14.737c2.971,0,5.127.594,6.411,1.765s1.947,3.008,1.947,5.434v4.586a3.453,3.453,0,0,0,.279,1.659h14.583a11.2,11.2,0,0,1-.63-4.295v-5.8a8.4,8.4,0,0,0-2.06-5.824,10.227,10.227,0,0,0-4.9-2.915l.219-.764a11.016,11.016,0,0,1,5.274,3.147,9.181,9.181,0,0,1,2.263,6.355v5.8a9.543,9.543,0,0,0,.692,4.24l.046.088Z",
    transform: "translate(-5599.962 -1578.027)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176834",
    "data-name": "Group 176834",
    transform: "translate(392.181 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61941",
    "data-name": "Path 61941",
    d: "M6325.924,1602.844H6310.21v-20.009H6311v19.214h14.124v-19.214h.795Z",
    transform: "translate(-6310.21 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176835",
    "data-name": "Group 176835",
    transform: "translate(412.161 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61942",
    "data-name": "Path 61942",
    d: "M6590.071,1602.844h-28.288v-20.009h.8v19.214h27.492a54.224,54.224,0,0,0,11.8-1.149,27.848,27.848,0,0,0,8.055-2.932,16.656,16.656,0,0,0,4.842-4.3,14.648,14.648,0,0,0,2.518-4.977,21.246,21.246,0,0,0,.646-5.33v-.527h.793v.527a21.949,21.949,0,0,1-.672,5.53,15.362,15.362,0,0,1-2.65,5.251,17.411,17.411,0,0,1-5.069,4.506,28.594,28.594,0,0,1-8.288,3.025A55.04,55.04,0,0,1,6590.071,1602.844Z",
    transform: "translate(-6561.784 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176836",
    "data-name": "Group 176836",
    transform: "translate(427.134 0.382)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61943",
    "data-name": "Path 61943",
    d: "M6761.82,1592.458H6750.3v-9.623h.793v8.829h10.728c4.732,0,8.321-.751,10.663-2.232a7.174,7.174,0,0,0,3.439-6.545v-.052h.8v.052C6776.717,1589.238,6771.7,1592.458,6761.82,1592.458Z",
    transform: "translate(-6750.299 -1582.835)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176837",
    "data-name": "Group 176837",
    transform: "translate(464.902 0.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61944",
    "data-name": "Path 61944",
    d: "M7287.18,1600.712h-17.3l-3.057-6.326h-21.907l-3.006,6.326h-16.074l9.985-20.186.711.353-9.417,19.039h14.293l3.006-6.326h22.905l3.058,6.326h15.491l-9.949-19.031.7-.368Z",
    transform: "translate(-7225.835 -1580.518)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176838",
    "data-name": "Group 176838",
    transform: "translate(487.687 0.208)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61945",
    "data-name": "Path 61945",
    d: "M7527.011,1584.692h-14.288l1.931-4.048.715.342-1.387,2.911h11.755l-1.417-2.908.714-.349Z",
    transform: "translate(-7512.723 -1580.641)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176839",
    "data-name": "Group 176839",
    transform: "translate(530.632 0.12)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61946",
    "data-name": "Path 61946",
    d: "M8073.355,1599.809h-15.767V1584.8l-4.155-4.739.6-.523,4.354,4.963v14.513h14.177v-14.405l4.329-5.067.6.516-4.138,4.844Z",
    transform: "translate(-8053.434 -1579.538)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_176857",
    "data-name": "Group 176857",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_176841",
    "data-name": "Group 176841",
    transform: "translate(14.973 9.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61947",
    "data-name": "Path 61947",
    d: "M1578.625,783.747h-17.8v-6.33h17.8a5.751,5.751,0,0,1,3.226.74,2.651,2.651,0,0,1,1.178,2.346v.105C1583.029,782.04,1582.264,783.747,1578.625,783.747Zm-17-.794h17c3.609,0,3.609-1.764,3.609-2.344V780.5c0-.567,0-2.292-3.609-2.292h-17Z",
    transform: "translate(-1560.83 -777.417)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176842",
    "data-name": "Group 176842",
    transform: "translate(0 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61948",
    "data-name": "Path 61948",
    d: "M1422.46,685.568a16.172,16.172,0,0,0-2.34-1.389,14.38,14.38,0,0,0-2.847-.974l-1.672-.39,1.674-.383a9.865,9.865,0,0,0,4.46-2.411,6.252,6.252,0,0,0,1.979-4.9v-.58a7.277,7.277,0,0,0-3.138-6.089c-2.117-1.608-5.805-2.423-10.963-2.423h-36.507v19.215h-.794V665.234h37.3c5.335,0,9.185.87,11.443,2.585a8.125,8.125,0,0,1,3.452,6.722v.58a7.1,7.1,0,0,1-2.238,5.486,11.047,11.047,0,0,1-3.49,2.193,14.342,14.342,0,0,1,1.677.66,16.924,16.924,0,0,1,2.458,1.457Zm-17.381-5.095h-17.795v-6.33h17.795a5.748,5.748,0,0,1,3.226.74,2.65,2.65,0,0,1,1.178,2.346v.105a2.711,2.711,0,0,1-1.175,2.384A5.666,5.666,0,0,1,1405.079,680.473Zm-17-.794h17c3.61,0,3.61-1.764,3.61-2.344v-.105c0-.567,0-2.292-3.61-2.292h-17Z",
    transform: "translate(-1372.312 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176843",
    "data-name": "Group 176843",
    transform: "translate(56.831 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61949",
    "data-name": "Path 61949",
    d: "M2103.636,685.243h-.794V666.029h-14.177v19.215h-.794V665.234h15.766Z",
    transform: "translate(-2087.87 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176844",
    "data-name": "Group 176844",
    transform: "translate(109.961 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61950",
    "data-name": "Path 61950",
    d: "M2796.917,685.427l-10.143-19.4h-19.652l-9.591,19.391-.712-.352,9.811-19.833h20.625l10.365,19.825Z",
    transform: "translate(-2756.819 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176845",
    "data-name": "Group 176845",
    transform: "translate(124.691 9.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61951",
    "data-name": "Path 61951",
    d: "M2951.953,790.643l-4.53-9.277L2943,790.639l-.717-.342,5.127-10.76,5.252,10.757Z",
    transform: "translate(-2942.287 -779.538)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176846",
    "data-name": "Group 176846",
    transform: "translate(157)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61952",
    "data-name": "Path 61952",
    d: "M3349.868,676.688h-.794v-.9a23.989,23.989,0,0,1,.509-5.039,17.579,17.579,0,0,1,7.017-10.076,26.3,26.3,0,0,1,8.246-3.379,50.33,50.33,0,0,1,12.355-1.357h2.056a59.606,59.606,0,0,1,9.05.637,37.754,37.754,0,0,1,6.928,1.653,24.126,24.126,0,0,1,4.986,2.44,16.079,16.079,0,0,1,3.432,2.9,14.3,14.3,0,0,1,2.034,3.118,12.521,12.521,0,0,1,1.033,2.971,13.926,13.926,0,0,1,.244,2.551v.685h-.794v-.685a13.151,13.151,0,0,0-.229-2.4,11.741,11.741,0,0,0-.971-2.776,13.539,13.539,0,0,0-1.921-2.944,15.281,15.281,0,0,0-3.263-2.746,23.322,23.322,0,0,0-4.821-2.357,36.976,36.976,0,0,0-6.779-1.615,58.811,58.811,0,0,0-8.928-.628H3377.2a49.539,49.539,0,0,0-12.158,1.332,25.545,25.545,0,0,0-7.993,3.264,16.786,16.786,0,0,0-6.69,9.589,23.134,23.134,0,0,0-.492,4.872Z",
    transform: "translate(-3349.074 -655.941)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176847",
    "data-name": "Group 176847",
    transform: "translate(172.499 10.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61953",
    "data-name": "Path 61953",
    d: "M3545.022,798.9h-.793v-.633c0-6.351,4.55-9.57,13.524-9.57a21.66,21.66,0,0,1,8.958,1.54,7.57,7.57,0,0,1,4.338,4.754l-.761.227a6.81,6.81,0,0,0-3.913-4.261,20.911,20.911,0,0,0-8.624-1.465c-4.272,0-7.508.747-9.618,2.222a7.4,7.4,0,0,0-3.113,6.554Z",
    transform: "translate(-3544.229 -788.7)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176848",
    "data-name": "Group 176848",
    transform: "translate(217.68 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61954",
    "data-name": "Path 61954",
    d: "M4145.242,685.537l-2.322-2.109,22.289-17.4h-17.315l-19.833,15.931V666.029h-14.179v19.215h-.793V665.234h15.767V680.3l18.759-15.068h19.9l-23.364,18.239,1.624,1.476Z",
    transform: "translate(-4113.089 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176849",
    "data-name": "Group 176849",
    transform: "translate(288.85 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61955",
    "data-name": "Path 61955",
    d: "M5051.947,685.243h-.794v-4.717H5024v-5.7h27.732v-8.8H5009.98v19.215h-.794V665.234h43.341v10.389H5024.8v4.109h27.151Z",
    transform: "translate(-5009.186 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176850",
    "data-name": "Group 176850",
    transform: "translate(335.771 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61956",
    "data-name": "Path 61956",
    d: "M5645.3,685.625c-.3-.085-.548-.15-.793-.205l-1.63-.368,1.62-.4a13.492,13.492,0,0,0,2.433-.871,13.231,13.231,0,0,0,2.455-1.536,6.915,6.915,0,0,0,1.968-2.495,7.883,7.883,0,0,0,.751-3.465v-.58a7.837,7.837,0,0,0-3.935-7.213c-2.675-1.632-6.769-2.459-12.169-2.459h-35.242v19.215h-.795V665.234H5636c5.548,0,9.782.867,12.583,2.576a8.68,8.68,0,0,1,4.315,7.891v.58a8.647,8.647,0,0,1-.832,3.811,7.686,7.686,0,0,1-2.2,2.777,13.991,13.991,0,0,1-2.6,1.628,14.58,14.58,0,0,1-1.849.718Zm-12.78-3.306h-17.584v-7.542h17.584a6.141,6.141,0,0,1,3.636.907,3.277,3.277,0,0,1,1.294,2.811v.053a3.34,3.34,0,0,1-1.293,2.849A6.065,6.065,0,0,1,5632.519,682.319Zm-16.789-.794h16.789c4.136,0,4.136-2.241,4.136-2.977v-.053a2.494,2.494,0,0,0-.969-2.171,5.406,5.406,0,0,0-3.167-.754H5615.73Z",
    transform: "translate(-5599.962 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176851",
    "data-name": "Group 176851",
    transform: "translate(392.181 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61957",
    "data-name": "Path 61957",
    d: "M6325.924,685.243h-.795V666.029H6311v19.215h-.795V665.234h15.714Z",
    transform: "translate(-6310.21 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176852",
    "data-name": "Group 176852",
    transform: "translate(412.161 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61958",
    "data-name": "Path 61958",
    d: "M6618.725,685.243h-.793v-1.054a19.2,19.2,0,0,0-.724-5.372,14.289,14.289,0,0,0-2.645-4.872,16.726,16.726,0,0,0-4.971-4.119,28.8,28.8,0,0,0-8.059-2.752,57.116,57.116,0,0,0-11.516-1.046h-27.439v19.215h-.8V665.234h28.235A57.914,57.914,0,0,1,6601.7,666.3a29.578,29.578,0,0,1,8.284,2.836,17.5,17.5,0,0,1,5.2,4.316,15.153,15.153,0,0,1,2.786,5.145,20,20,0,0,1,.754,5.594Z",
    transform: "translate(-6561.784 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176853",
    "data-name": "Group 176853",
    transform: "translate(427.134 11.018)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61959",
    "data-name": "Path 61959",
    d: "M6776.717,804.4h-.8v-.264a7.062,7.062,0,0,0-3.439-6.464c-2.342-1.465-5.929-2.207-10.663-2.207h-10.728V804.4h-.793v-9.729h11.521c9.882,0,14.9,3.185,14.9,9.465Z",
    transform: "translate(-6750.299 -794.673)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176854",
    "data-name": "Group 176854",
    transform: "translate(474.886 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61960",
    "data-name": "Path 61960",
    d: "M7391.641,685.427l-10.143-19.4h-19.65l-9.592,19.391-.713-.352,9.812-19.833h20.625l10.365,19.825Z",
    transform: "translate(-7351.543 -665.234)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176855",
    "data-name": "Group 176855",
    transform: "translate(489.616 9.816)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61961",
    "data-name": "Path 61961",
    d: "M7546.679,790.643l-4.531-9.277-4.418,9.274-.718-.342,5.128-10.76,5.252,10.757Z",
    transform: "translate(-7537.012 -779.538)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_176856",
    "data-name": "Group 176856",
    transform: "translate(512.851 0.738)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_61962",
    "data-name": "Path 61962",
    d: "M7847.338,685.505l-17.779-20.271h18.985l11.258,13.334,11.468-13.334h17.438L7871.4,685.5l-.6-.516,16.188-18.957h-15.35L7859.8,679.793l-11.622-13.764H7831.31l16.626,18.953Z",
    transform: "translate(-7829.559 -665.234)",
    fill: "#fff"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAfterBlackFridayDesktop);
export default __webpack_public_path__ + "static/media/after-black-friday-desktop.412f5475d1c45233d86e1c115e2d9a5c.svg";
export { ForwardRef as ReactComponent };